export default "__VITE_ASSET__51f5ba8c__"